var _path, _circle, _path2, _mask, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdministration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1057 5.48666L6.06301 7.72997",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.2253,
    cy: 12.5531,
    r: 2.66447,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64748 0.789786C9.93502 0.641523 10.2765 0.641523 10.5641 0.789786L18.1229 4.68734C18.4839 4.87346 18.6965 5.2594 18.6608 5.66396L18.5241 7.21408C18.1076 7.11309 17.6726 7.05957 17.225 7.05957C16.9883 7.05957 16.755 7.07455 16.5261 7.10361L16.6096 6.15721L10.1058 2.8037L3.59205 6.16233L3.71804 7.89867C4.02896 12.1834 6.6348 15.9643 10.5284 17.7798C10.5528 17.7912 10.5821 17.8045 10.6149 17.8194C10.7005 17.8584 10.8104 17.9084 10.9228 17.9644C10.5982 18.357 10.32 18.8006 10.1062 19.3011C10.0516 19.429 10.0025 19.5537 9.9588 19.6755C9.86564 19.6616 9.77289 19.6342 9.68317 19.5924C5.13238 17.4704 2.08668 13.0514 1.72329 8.04341L1.54951 5.64851C1.52053 5.24908 1.73265 4.87088 2.0886 4.68734L9.64748 0.789786Z",
    fill: "currentColor"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_4521_2099",
    maskUnits: "userSpaceOnUse",
    x: 11.5273,
    y: 16.9218,
    width: 12,
    height: 6,
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 11.5273,
    y: 16.9218,
    width: 12,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5273 20.8818H20.9231C19.0879 18.4077 15.3745 18.4166 13.5273 20.8818Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5273 20.8818L11.9268 19.6825C11.4726 20.2886 11.3998 21.0993 11.7387 21.7766C12.0776 22.454 12.77 22.8818 13.5273 22.8818V20.8818ZM20.9231 20.8818V22.8818C21.6788 22.8818 22.3699 22.4559 22.7096 21.7809C23.0493 21.1059 22.9796 20.2971 22.5294 19.6902L20.9231 20.8818ZM13.5273 22.8818H20.9231V18.8818H13.5273V22.8818ZM22.5294 19.6902C19.8885 16.13 14.5677 16.1579 11.9268 19.6825L15.1279 22.0811C16.1812 20.6752 18.2873 20.6854 19.3168 22.0733L22.5294 19.6902Z",
    mask: "url(#path-4-outside-1_4521_2099)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministration);
export default __webpack_public_path__ + "static/media/administration.c6fc87be1e7a38ec5a7ad2377cb483a8.svg";
export { ForwardRef as ReactComponent };